import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";

export interface StepProps {
  title: string;
  message: string;
  id?: string;
}

const Step = (props: StepProps) => {
  const { title, message, id } = props;

  return (
    <MDBox id={id} mt={2} mb={2} sx={{ scrollMarginTop: "96px" }}>
      <MDTypography variant="h5" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="body2" color="text.secondary">
        {message}
      </MDTypography>
    </MDBox>
  );
};

export default Step;
